// extracted by css-extract-rspack-plugin
export default {"container":"container-NCuSgl","toggle":"toggle-VjAFeH","label":"label-uvGFmh"};